// Pezzi comuni delle schede di Impostazioni
import { comeData } from '../../utils/documenti';

export const errore = (e, riserva) => (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : riserva);

// "14 set 2026 09:40" (conAnno) o "14 set 09:40"
export const quandoBreve = (valore, conAnno = false) => {
  const d = comeData(valore);
  if (!d) return '';
  const giorno = d.toLocaleDateString('it-IT', { day: 'numeric', month: 'short', ...(conAnno ? { year: 'numeric' } : {}) });
  return `${giorno} ${d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}`;
};
